import { EFinancingProgram } from '@if/core/types'
import { PageContainer, SplitContainer } from '@if/mui'
import { Stack } from '@mui/material'
import { useFundingSummaryByIdQuery } from '@src/data/api/credit-api/credit-api'
import { FundingSummaryDto } from '@src/types/FundingSummaryDto'
import { useTranslation } from 'react-i18next'
import ClientInformationCard from './components/ClientInformationCard'
import FundingConfirmationCard from './components/FundingConfirmationCard'
import FundingSummaryButtonGroup from './components/FundingSummaryButtonGroup'
import FundingSummarySkeleton from './components/FundingSummarySkeleton'
import MerchantInformationCard from './components/MerchantInformationCard'
import NeedHelpCard from './components/NeedHelpCard'
import NotesCard from './components/NotesCard'

const FundingSummaryBody = ({ fundingSummary }: { fundingSummary: FundingSummaryDto }) => (
  <SplitContainer
    main={
      <Stack spacing={2.5}>
        <FundingConfirmationCard fundingSummary={fundingSummary} />
        <MerchantInformationCard fundingSummary={fundingSummary} />
        <ClientInformationCard fundingSummary={fundingSummary} />
      </Stack>
    }
    aside={
      <Stack spacing={2.5}>
        <FundingSummaryButtonGroup />
        <NeedHelpCard fundingSummary={fundingSummary} />
        <NotesCard fundingSummary={fundingSummary} />
      </Stack>
    }
  />
)

const fundingSummaryParams = ['financingProgramId', 'id'] as const

const useFundingSummaryPrimary = ({ financingProgramId, id }: { financingProgramId: string; id: string }) => ({
  fundingSummary: useFundingSummaryByIdQuery(id, financingProgramId as EFinancingProgram),
})

const FundingSummary = () => {
  const { t } = useTranslation()

  return (
    <PageContainer
      params={fundingSummaryParams}
      usePrimary={useFundingSummaryPrimary}
      loadingContent={<FundingSummarySkeleton />}
      back={({ financingProgramId, id }) => ({
        to: `/credits/${financingProgramId}/${id}`,
        label: t('viewCreditApplication.backToApplications'),
      })}
      title={t('fundingSummary.formTitle')}
      subtitle={t('fundingSummary.guaranteeOfPayment')}
    >
      {({ fundingSummary }) => <FundingSummaryBody fundingSummary={fundingSummary} />}
    </PageContainer>
  )
}

export default FundingSummary
